export default "__VITE_ASSET__BqjsI5sh__"